import { Injectable, inject, signal, computed, effect, InjectionToken } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';

export const RECENT_LOGINS_KEY = new InjectionToken<string>('RECENT_LOGINS_KEY');
const MAX_RECENT_LOGINS = 20;

@Injectable()
export class RecentLoginsService {
  private storage = inject(LocalStorageService);
  private key: string = inject(RECENT_LOGINS_KEY);

  readonly recentByLastUsed = signal<string[]>(this.retrieve());

  readonly usernamesForDropdown = computed(() => {
    return [...this.recentByLastUsed()].sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }));
  });

  constructor() {
    effect(() => {
      const recentByLastUsed = this.recentByLastUsed();
      this.storage.store(this.key, recentByLastUsed);
    });
  }

  store(username: string): void {
    const normalized = String(username ?? '').trim();
    if (!normalized) return;

    this.recentByLastUsed.update((current) => {
      return [normalized, ...current.filter((u) => u !== normalized)].slice(0, MAX_RECENT_LOGINS);
    });
  }

  private retrieve(): string[] {
    const raw = this.storage.retrieve(this.key);
    if (!Array.isArray(raw)) return [];

    // старый формат — массив объектов
    if (raw.length > 0 && typeof raw[0] === 'object' && raw[0] !== null) {
      return (raw as { username?: unknown }[])
        .map((x) => x?.username)
        .filter((x): x is string => typeof x === 'string');
    }

    // новый формат — массив строк
    return raw.filter((x): x is string => typeof x === 'string');
  }
}
